import { FunctionalComponent, h } from 'preact';
import countries from './countries'

// https://github.com/HatScripts/circle-flags
const CDN_URL = 'https://hatscripts.github.io/circle-flags/flags/'
const FILE_SUFFIX = 'svg'

const UNKNOWN_FLAG = 'xx'

const FLAGS_MAP = {
  'cym': 'gb-wls'
}

const convert = (code: keyof typeof FLAGS_MAP) => FLAGS_MAP[code] || code;

const parseCountryCode = (countryCode: string) => {
  if (!countryCode) {
    return UNKNOWN_FLAG;
  }

  const code = convert(countryCode.toLowerCase() as keyof typeof FLAGS_MAP);
  return countries[code as keyof typeof countries] ? code : UNKNOWN_FLAG;
}

interface CircleFlagProps {
  countryCode: string;
  cdnUrl?: string;
  height?: number;
  title?: string;
  className?: string;
}

export const CircleFlag: FunctionalComponent<CircleFlagProps> = ({
  className,
  countryCode,
  cdnUrl = CDN_URL,
  height,
  title,
}) => {
  const code = parseCountryCode(countryCode).toLowerCase();

  return (
    <img
      className={className}
      height={height}
      title={title || code}
      src={`${cdnUrl}${code}.${FILE_SUFFIX}`}
    />
  );
}
